(() => {
  const reelSelector = '[data-hd-collection-reel]';
  const initializedAttr = 'data-hd-reel-ready';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const clampSpeed = (value) => {
    const seconds = Number.parseInt(value, 10);
    if (!Number.isFinite(seconds)) return 5000;
    return Math.min(Math.max(seconds, 3), 9) * 1000;
  };

  const initReel = (reel) => {
    if (!reel || reel.hasAttribute(initializedAttr)) return;

    const slides = Array.from(reel.querySelectorAll('[data-hd-reel-slide]'));
    const thumbs = Array.from(reel.querySelectorAll('[data-hd-reel-thumb]'));
    const prev = reel.querySelector('[data-hd-reel-prev]');
    const next = reel.querySelector('[data-hd-reel-next]');
    const progress = reel.querySelector('[data-hd-reel-progress]');
    const shouldAutoplay = reel.dataset.hdAutoplay === 'true' && !reducedMotion.matches && slides.length > 1;
    const speed = clampSpeed(reel.dataset.hdSpeed);

    let activeIndex = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active')),
    );
    let timer = null;
    let paused = false;

    reel.setAttribute(initializedAttr, 'true');
    reel.style.setProperty('--hd-reel-duration', `${speed}ms`);

    const restartProgress = () => {
      if (!progress) return;
      reel.classList.remove('is-autoplaying');
      progress.getBoundingClientRect();
      if (shouldAutoplay && !paused) {
        reel.classList.add('is-autoplaying');
      }
    };

    const setActive = (nextIndex, userInitiated = false) => {
      if (!slides.length) return;
      const normalizedIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === normalizedIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((focusable) => {
          focusable.tabIndex = isActive ? 0 : -1;
        });
      });

      thumbs.forEach((thumb, index) => {
        const isActive = index === normalizedIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      activeIndex = normalizedIndex;
      if (userInitiated) {
        pause(false);
        window.setTimeout(() => resume(), 2400);
      }
      restartProgress();
    };

    const clearTimer = () => {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    };

    const schedule = () => {
      clearTimer();
      if (!shouldAutoplay || paused) return;
      timer = window.setTimeout(() => {
        setActive(activeIndex + 1);
        schedule();
      }, speed);
    };

    function pause(clear = true) {
      paused = true;
      reel.classList.remove('is-autoplaying');
      if (clear) clearTimer();
    }

    function resume() {
      if (!shouldAutoplay) return;
      paused = false;
      restartProgress();
      schedule();
    }

    prev?.addEventListener('click', () => {
      setActive(activeIndex - 1, true);
      schedule();
    });

    next?.addEventListener('click', () => {
      setActive(activeIndex + 1, true);
      schedule();
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number.parseInt(thumb.dataset.index || '0', 10);
        setActive(index, true);
        schedule();
      });
    });

    reel.addEventListener('pointerenter', () => pause());
    reel.addEventListener('pointerleave', () => resume());
    reel.addEventListener('focusin', () => pause());
    reel.addEventListener('focusout', () => resume());

    setActive(activeIndex);
    schedule();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(reelSelector).forEach(initReel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
